import React from 'react'

import collapsed from './../../../UI/general/collapse.svg'
import close from "./../../../UI/general/close.svg"
import collapse from './../../../UI/general/collapse.svg'

import all from './../../../UI/general/all.svg'



interface Props {
    locationData: any,
    colorsData: any,
    handleFilteredRoute: any,
    handleSelectPOI: any,
    handleMenuSelection: any
    routesActive: boolean,
    POISActive: boolean
    isLocation: any,
    handleChangeToMapaIlustrado: any,
    activeIllustratedMap: any
}

interface State {
    isCollapsed: boolean,
    isRoutesOpened: boolean,
    isPOISOpened: boolean,
    selectedRouteIndex: number
    routeIndex: number,
    isGoogleMaps: boolean,
    selectedPOIIndex: number,
    POIIndex: number,
}


declare const window: any;

class SidebarMaps extends React.Component<Props,State>{

    constructor(props:Props){
        super(props);
        this.state = {
            isCollapsed: true,
            isRoutesOpened:true,
            isPOISOpened:true,
            selectedRouteIndex: 0,
            routeIndex: -1,
            selectedPOIIndex: -1,
            POIIndex: -1,
            isGoogleMaps: false
        }
    }
    componentDidMount(): void {
        this.setState({
            isCollapsed: !this.props.isLocation
        })
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if(prevProps.isLocation !== this.props.isLocation){
            this.setState({
                isCollapsed: !this.props.isLocation
            })
        }
    }

    handleChangeMap = (payload: any) => {
        if(this.props.activeIllustratedMap){
            this.props.handleChangeToMapaIlustrado(true, payload)
        }
    }

    render(): React.ReactNode {
        return(
            <React.Fragment>
                <div className={this.state.isCollapsed ? 'sidebar-collapse-btn-collapsed':'sidebar-collapse-btn'} onClick={() => {this.setState({isCollapsed: !this.state.isCollapsed})}}>
                    <img src={collapsed} alt=""/>
                </div>
                <div className={this.state.isCollapsed ? 'sidebar-map-container-collapsed':'sidebar-map-container'}>
                    <div
                        className="properties-close-btn"
                        onClick={() => {
                            this.setState({
                                isCollapsed: true
                            })
                            setTimeout(() => {
                                this.props.handleMenuSelection('')
                            }, 500)
                        }}
                    >
                        <img src={close} alt=""></img>
                    </div>
                    <div className='amenities-img-container'>
                        <img src={'./UI/menu/ubicacion.svg'} alt=''/>
                    </div>
                    <div className='amenities-name-container'>{"UBICACIÓN".toUpperCase()}</div>
                    <div className='location-container'>
                        <div className='location-vias-general-container'>
                            <div 
                            className='location-vias-general-btn' 
                            onClick={() => {
                                this.setState({isRoutesOpened: !this.state.isRoutesOpened})
                                this.handleChangeMap(this.props.locationData.mapa_ilustrado_vias)
                                if(this.props.activeIllustratedMap){
                                    this.setState({
                                        isPOISOpened: false
                                    })
                                }
                            }}
                            style={{
                                backgroundColor: this.state.isRoutesOpened ? this.props.colorsData.main_buttons:'#fff',
                                color: this.state.isRoutesOpened ? this.props.colorsData.secondary_text: '#000'
                            }}
                            >
                                <img src={this.props.locationData.routes_icon} alt='' className='location-general-btn-icon' style={{filter: this.state.isRoutesOpened ? 'invert(1) brightness(100%)':'none'}}/>
                                <div className='location-general-btn-text'>Vías de acceso</div>
                                <img 
                                src={collapse} 
                                alt='' 
                                className='collapse-location-btn'
                                style={{
                                    filter: this.state.isRoutesOpened ? 'invert(1) brightness(100%)':'none',
                                    transform: this.state.isRoutesOpened ? 'none':'rotate(-90deg)',
                                    transition: 'all 0.2s ease-in-out'
                                }}
                                />
                            </div>
                            {
                                <React.Fragment>
                                   {this.props.locationData.mapa_ilustrado_vias !== null ?
                                   <div className='radio-btns-location-container'>
                                        <label>
                                            <input 
                                            type='radio' 
                                            checked={this.state.isGoogleMaps} 
                                            onChange={() => {
                                                this.setState({isGoogleMaps: true})
                                                this.props.handleChangeToMapaIlustrado(false, '')
                                            }}
                                            />
                                            Google Maps
                                        </label>
                                        <label>
                                            <input type='radio' checked={!this.state.isGoogleMaps} onChange={() => {
                                                this.setState({isGoogleMaps: false})
                                                this.props.handleChangeToMapaIlustrado(true, this.props.locationData.mapa_ilustrado_vias)
                                                this.setState({
                                                    isRoutesOpened: true,
                                                    isPOISOpened: false
                                                })
                                                }}/>
                                            Mapa ilustrado
                                        </label>
                                </div>:null
                                }

                                    {
                                        this.state.isGoogleMaps ?
                                        <div className={this.state.isRoutesOpened ? 'vias-main-container':'vias-main-container-collapsed'}>
                                            <div 
                                                className='individual-via-container'
                                                style={{
                                                    backgroundColor: this.state.selectedRouteIndex === 0 ? '#E0E0E0' : this.state.routeIndex === 0 ? '#EEEEEE':'#FFFFFF',
                                                }}
                                                onClick={() => {
                                                    this.props.handleFilteredRoute('')
                                                    this.setState({
                                                        selectedRouteIndex: 0,
                                                        selectedPOIIndex: -1
                                                    })
                                                }}
                                                onMouseEnter={() => {
                                                    this.setState({
                                                        routeIndex: 0
                                                    })
                                                }}
                                                onMouseLeave={() => {
                                                    this.setState({
                                                        routeIndex: -1
                                                    })
                                                }}
                                            >
                                                <img src={all} alt=''/>
                                                <div className='individual-via-name'>Ver todas</div>
                                            </div>
                                            {
                                                this.props.locationData.routes.map((route: any, index: number) => 
                                                    <div
                                                        className='individual-via-container'
                                                        onClick={() => {
                                                            this.props.handleFilteredRoute(route.name)
                                                            this.setState({
                                                                selectedRouteIndex: index + 1
                                                            })
                                                        }}
                                                        onMouseEnter={() => {
                                                            this.setState({
                                                                routeIndex: index + 1 
                                                            })
                                                        }}
                                                        onMouseLeave={() => {
                                                            this.setState({
                                                                routeIndex: -1
                                                            })
                                                        }}
                                                        style={{
                                                            backgroundColor: this.state.selectedRouteIndex === index + 1 ? '#E0E0E0' : this.state.routeIndex === index + 1 ? '#EEEEEE':'#FFFFFF'
                                                        }}
                                                    >
                                                        <div className='color-via-container' style={{backgroundColor: route.color}}/>
                                                        <div className='individual-via-name'>
                                                            {route.name}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>:null
                                    }
                                </React.Fragment>
                            }
                        </div>

                        {
                            this.state.isRoutesOpened ?
                            <hr className='hr-routes' style={{animation: 'fadein 1s ease-in-out 1'}}/>:null
                        }
    
                        <div className='location-vias-general-container'>
                            <div 
                            className='location-vias-general-btn' 
                            onClick={() => {
                                this.setState({isPOISOpened: !this.state.isPOISOpened})
                                this.handleChangeMap(this.props.locationData.mapa_ilustrado_pois)
                                if(this.props.activeIllustratedMap){
                                    this.setState({
                                        isRoutesOpened: false
                                    })
                                }
                            }
                            }
                            style={{
                                backgroundColor: this.state.isPOISOpened ? this.props.colorsData.main_buttons:'#fff',
                                color: this.state.isPOISOpened ? this.props.colorsData.secondary_text: '#000'
                            }}
                            >
                                <img src={this.props.locationData.POIS_icon} alt='' className='location-general-btn-icon' style={{filter: this.state.isPOISOpened ? 'invert(1) brightness(100%)':'none'}}/>
                                <div className='location-general-btn-text'>Puntos de interés</div>
                                <img 
                                src={collapse} 
                                alt='' 
                                className='collapse-location-btn'
                                style={{
                                    filter: this.state.isPOISOpened ? 'invert(1) brightness(100%)':'none',
                                    transform: this.state.isPOISOpened ? 'none':'rotate(-90deg)',
                                    transition: 'all 0.2s ease-in-out'
                                }}
                                />
                            </div>
                            {

                                <React.Fragment>
                                    {this.props.locationData.mapa_ilustrado_pois !== null ?
                                        <div className='radio-btns-location-container'>
                                            <label>
                                                <input type='radio' checked={this.state.isGoogleMaps} onChange={() => {
                                                    this.setState({isGoogleMaps: true})
                                                    this.props.handleChangeToMapaIlustrado(false, '')
                                                    }}/>
                                                Google Maps
                                            </label>
                                            <label>
                                                <input type='radio' checked={!this.state.isGoogleMaps} onChange={() => {
                                                    this.setState({isGoogleMaps: false})
                                                    this.props.handleChangeToMapaIlustrado(true, this.props.locationData.mapa_ilustrado_pois)
                                                    this.setState({
                                                        isRoutesOpened: false,
                                                        isPOISOpened: true
                                                    })
                                                    }}/>
                                                Mapa ilustrado
                                            </label>
                                        </div>:null
                                    }

                                    {this.state.isGoogleMaps ?
                                        <div className={this.state.isPOISOpened ?'vias-main-container':'vias-main-container-collapsed'}>
                                        {
                                            this.props.locationData.POIS.map((poi: any, index: number) => 
                                                <div
                                                    className='individual-via-container'
                                                    onClick={() => {
                                                        this.props.handleSelectPOI(poi)
                                                        this.setState({
                                                            selectedPOIIndex: index,
                                                            selectedRouteIndex: -1
                                                        })
                                                    }}
                                                    onMouseEnter={() => {
                                                        this.setState({
                                                            POIIndex: index
                                                        })
                                                    }}
                                                    onMouseLeave={() => {
                                                        this.setState({
                                                            POIIndex: -1
                                                        })
                                                    }}
                                                    style={{
                                                        backgroundColor: this.state.selectedPOIIndex === index ? '#E0E0E0' : this.state.POIIndex === index ? '#EEEEEE':'#FFFFFF'
                                                    }}
                                                >
                                                    <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+poi.icon} alt=''/>
                                                    <div className='individual-via-name'>
                                                        {poi.slug}
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>:null
                                    }
                                </React.Fragment>
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default SidebarMaps